export default __webpack_public_path__ + "static/media/thumb.5b4fade5.png";